// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin: 0 auto;
}

.module {
  border: 1px solid #ddd;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 5px;
}

.module-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  color: #0056b3;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type=text],
textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

input[type=file] {
  margin-bottom: 10px;
}

.step {
  margin-bottom: 15px;
}

button {
  background-color: #0056b3;
  color: white;
  padding: 10px 15px;
  border: none;
  margin-bottom: 20px;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #ffc107;
}

.navigation {
  text-align: center;
}

.navigation button {
  margin: 0 5px;
}

#progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-bottom: 20px;
}

#progress-bar {
  width: 20%; /* Starts at 0%, adjust based on module completed */
  height: 20px;
  background-color: #4caf50;
  text-align: center;
  line-height: 20px;
  color: white;
  border-radius: 5px;
}

.hidden {
  display: none;
}

/* .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 80px;
    background-color: #f8f9fa;
  }

  .logo-container {
    text-align: center;
    flex: 1;
  }

  .logo {
    width: 85px;
    height: 85;
    object-fit: cover;
  }

  .app-name {
    font-size: 24px;
    font-weight: bold;
    margin-top: 10px;
  } */
.user-panel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-image-container {
  position: relative;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
}

.user-status-circle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  border: 2px solid white;
}

.logout-button {
  margin-left: 15px;
}

.logout-button .btn {
  padding: 5px 10px;
  font-size: 14px;
}

.user-panel-options {
  display: block; /* Ensures the panel is shown when isPanelVisible is true */
  position: absolute;
  top: 40px; /* Adjust the position */
  left: 0;
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  list-style: none;
}

.user-panel-options ul {
  margin: 0;
  padding: 0;
}

.user-panel-options li {
  margin: 5px 0;
}

.user-panel-options li a {
  text-decoration: none;
  color: #333;
}

.border-theme {
  color: #1c625b;
  border-color: #00a95c;
}

.user-panel-options li a:hover {
  color: #007bff;
}

/* Styling the rounded panel containing the header */
.rounded-panel {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Vertical line before the header */
.vertical-line {
  height: 40px;
  width: 4px;
  background-color: #646464;
  margin-right: 15px;
}

/* Page title styles */
.page-title {
  font-size: 20px;
  color: #797979;
  text-align: left;
  margin: 0; /* Remove default margin */
  font-weight: 600;
}

/* Stepper Card Styling */
.card {
  border-radius: 2px;
  border: none;
  background: #ffffff;
  margin-bottom: 20px;
}

/* Wizard Header */
.wizard-header {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

/* Progress Line */
.wizard-header::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 10%;
  width: 80%;
  height: 4px;
  background: #ddd;
  z-index: 0;
}

/* Individual Steps */
.wizard-step {
  width: 150px; /* Set a fixed width */
  min-width: 150px;
  text-align: center;
  position: relative;
  z-index: 1;
  flex: 1;
  cursor: pointer;
}

/* Step Circle */
.step-circle {
  width: 40px;
  height: 40px;
  background: #ccc;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  border-radius: 50%;
  line-height: 40px;
  margin: auto;
  transition: all 0.3s ease;
}

/* Step Label */
.step-label {
  display: block;
  font-size: 14px;
  margin-top: 5px;
  font-weight: bold;
  color: #777;
}

/* Active Step Styling */
.wizard-step.active .step-circle {
  background: rgb(70, 159, 84);
}

.wizard-step.active .step-label {
  color: rgb(70, 159, 84);
}

/* Progress Line for Completed Steps */
.wizard-step.active ~ .wizard-step .step-circle {
  background: #ccc;
}

cdk-step .cdk-step-header {
  display: none !important;
}

.btn-submit {
  background-color: #00a95c;
}

.btn {
  margin-top: 20px;
  margin-right: 10px; /* Corrected margin syntax */
}

/* Autocomplete dropdown */
.autocomplete-dropdown {
  position: absolute;
  z-index: 1000;
  width: 100%;
}

.autocomplete-dropdown .list-group-item {
  cursor: pointer;
  font-size: 0.85rem;
}

.autocomplete-dropdown .list-group-item:hover {
  background-color: #f8f9fa;
}

/* Selected DCIs list */
.selected-dcis {
  background-color: #f8f9fa;
}

.selected-dcis .bg-light {
  transition: all 0.2s ease;
}

.selected-dcis .bg-light:hover {
  background-color: #e9ecef !important;
}

/* Submit button */
.btn-submit {
  background-color: #0d6efd;
  color: white;
  min-width: 150px;
}

.btn-submit:hover {
  background-color: #0b5ed7;
}

.btn-submit:disabled {
  background-color: #6c757d;
  opacity: 0.65;
}

.file-upload-container {
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 5px;
  transition: all 0.3s ease;
}

.file-upload-container.upload-success {
  border-color: #28a745;
}

.file-upload-container.upload-error {
  border-color: #dc3545;
}

.upload-progress {
  margin-top: 5px;
}

.upload-status {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
}

.progress {
  height: 20px;
  margin-top: 5px;
}

.progress-bar {
  line-height: 20px;
  font-size: 12px;
}

input[type=file].form-control {
  padding-right: 2.5rem; /* room for the icon */
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/demandes/components/renouvellement-amm/renouvellement-amm.component.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;AAAF;;AAGA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA,EAAA,yCAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EAEE,kBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,UAAA,EAAA,mDAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA,EAAA,2DAAA;EACA,kBAAA;EACA,SAAA,EAAA,wBAAA;EACA,OAAA;EACA,iBAAA;EACA,sBAAA;EAEA,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,SAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,qBAAA;EACA,WAAA;AAFF;;AAIA;EACE,cAAA;EACA,qBAAA;AADF;;AAGA;EACE,cAAA;AAAF;;AAEA,oDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA,oCAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA,sBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA,EAAA,0BAAA;EACA,gBAAA;AACF;;AACA,yBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA,kBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAEF;;AACA,kBAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAEF;;AACA,qBAAA;AACA;EACE,YAAA,EAAA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;AAEF;;AACA,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AAEF;;AACA,eAAA;AACA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAEF;;AACA,wBAAA;AACA;EACE,4BAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA,sCAAA;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,wBAAA;AAGF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,kBAAA,EAAA,4BAAA;AAGF;;AADA,0BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAIF;;AADA;EACE,eAAA;EACA,kBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA,uBAAA;AACA;EACE,yBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,oCAAA;AAIF;;AADA,kBAAA;AACA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,yBAAA;EACA,aAAA;AAIF;;AAFA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAKF;;AAFA;EACE,qBAAA;AAKF;;AAFA;EACE,qBAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAKF;;AAFA;EACE,YAAA;EACA,eAAA;AAKF;;AAFA;EACE,iBAAA;EACA,eAAA;AAKF;;AAHA;EACE,qBAAA,EAAA,sBAAA;AAMF;AACA,41YAA41Y","sourcesContent":[".container {\n  // max-width: 600px;\n  margin: 0 auto;\n}\n\n.module {\n  border: 1px solid #ddd;\n  margin-bottom: 20px;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.module-title {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #0056b3;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n}\n\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\ninput[type=\"file\"] {\n  margin-bottom: 10px;\n}\n\n.step {\n  margin-bottom: 15px;\n}\n\nbutton {\n  background-color: #0056b3;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #ffc107;\n}\n\n.navigation {\n  // margin-top: 20px;\n  text-align: center;\n}\n\n.navigation button {\n  margin: 0 5px;\n}\n#progress-bar-container {\n  width: 100%;\n  background-color: #f3f3f3;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n#progress-bar {\n  width: 20%; /* Starts at 0%, adjust based on module completed */\n  height: 20px;\n  background-color: #4caf50;\n  text-align: center;\n  line-height: 20px;\n  color: white;\n  border-radius: 5px;\n}\n\n.hidden {\n  display: none;\n}\n\n/* .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 80px;\n    background-color: #f8f9fa;\n  }\n  \n  .logo-container {\n    text-align: center;\n    flex: 1;\n  }\n  \n  .logo {\n    width: 85px;\n    height: 85;\n    object-fit: cover;\n  }\n  \n  .app-name {\n    font-size: 24px;\n    font-weight: bold;\n    margin-top: 10px;\n  } */\n\n.user-panel {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.user-image-container {\n  position: relative;\n}\n\n.user-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #ccc;\n}\n\n.user-status-circle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  background-color: green;\n  border-radius: 50%;\n  border: 2px solid white;\n}\n\n.logout-button {\n  margin-left: 15px;\n}\n\n.logout-button .btn {\n  padding: 5px 10px;\n  font-size: 14px;\n}\n\n.user-panel-options {\n  display: block; /* Ensures the panel is shown when isPanelVisible is true */\n  position: absolute;\n  top: 40px; /* Adjust the position */\n  left: 0;\n  background: white;\n  border: 1px solid #ddd;\n  // box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n  padding: 10px;\n  list-style: none;\n}\n\n.user-panel-options ul {\n  margin: 0;\n  padding: 0;\n}\n\n.user-panel-options li {\n  margin: 5px 0;\n}\n\n.user-panel-options li a {\n  text-decoration: none;\n  color: #333;\n}\n.border-theme {\n  color: #1c625b;\n  border-color: #00a95c;\n}\n.user-panel-options li a:hover {\n  color: #007bff;\n}\n/* Styling the rounded panel containing the header */\n.rounded-panel {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  border-radius: 15px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Vertical line before the header */\n.vertical-line {\n  height: 40px;\n  width: 4px;\n  background-color: #646464;\n  margin-right: 15px;\n}\n\n/* Page title styles */\n.page-title {\n  font-size: 20px;\n  color: #797979;\n  text-align: left;\n  margin: 0; /* Remove default margin */\n  font-weight: 600;\n}\n/* Stepper Card Styling */\n.card {\n  border-radius: 2px;\n  border: none;\n  background: #ffffff;\n  margin-bottom: 20px;\n}\n\n/* Wizard Header */\n.wizard-header {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n/* Progress Line */\n.wizard-header::before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: 10%;\n  width: 80%;\n  height: 4px;\n  background: #ddd;\n  z-index: 0;\n}\n\n/* Individual Steps */\n.wizard-step {\n  width: 150px; /* Set a fixed width */\n  min-width: 150px;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  cursor: pointer;\n}\n\n/* Step Circle */\n.step-circle {\n  width: 40px;\n  height: 40px;\n  background: #ccc;\n  color: #fff;\n  font-weight: bold;\n  font-size: 18px;\n  border-radius: 50%;\n  line-height: 40px;\n  margin: auto;\n  transition: all 0.3s ease;\n}\n\n/* Step Label */\n.step-label {\n  display: block;\n  font-size: 14px;\n  margin-top: 5px;\n  font-weight: bold;\n  color: #777;\n}\n\n/* Active Step Styling */\n.wizard-step.active .step-circle {\n  background: rgb(70, 159, 84);\n}\n\n.wizard-step.active .step-label {\n  color: rgb(70, 159, 84);\n}\n\n/* Progress Line for Completed Steps */\n.wizard-step.active ~ .wizard-step .step-circle {\n  background: #ccc;\n}\ncdk-step .cdk-step-header {\n  display: none !important;\n}\n\n.btn-submit {\n  background-color: #00a95c;\n}\n\n.btn {\n  margin-top: 20px;\n  margin-right: 10px; /* Corrected margin syntax */\n}\n/* Autocomplete dropdown */\n.autocomplete-dropdown {\n  position: absolute;\n  z-index: 1000;\n  width: 100%;\n}\n\n.autocomplete-dropdown .list-group-item {\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.autocomplete-dropdown .list-group-item:hover {\n  background-color: #f8f9fa;\n}\n\n/* Selected DCIs list */\n.selected-dcis {\n  background-color: #f8f9fa;\n}\n\n.selected-dcis .bg-light {\n  transition: all 0.2s ease;\n}\n\n.selected-dcis .bg-light:hover {\n  background-color: #e9ecef !important;\n}\n\n/* Submit button */\n.btn-submit {\n  background-color: #0d6efd;\n  color: white;\n  min-width: 150px;\n}\n\n.btn-submit:hover {\n  background-color: #0b5ed7;\n}\n\n.btn-submit:disabled {\n  background-color: #6c757d;\n  opacity: 0.65;\n}\n.file-upload-container {\n  position: relative;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 5px;\n  transition: all 0.3s ease;\n}\n\n.file-upload-container.upload-success {\n  border-color: #28a745;\n}\n\n.file-upload-container.upload-error {\n  border-color: #dc3545;\n}\n\n.upload-progress {\n  margin-top: 5px;\n}\n\n.upload-status {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2rem;\n}\n\n.progress {\n  height: 20px;\n  margin-top: 5px;\n}\n\n.progress-bar {\n  line-height: 20px;\n  font-size: 12px;\n}\ninput[type=\"file\"].form-control {\n  padding-right: 2.5rem; /* room for the icon */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
